import type { PaymentProvider } from "@zotlo-shared/elements/common/payment/types";

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server) {
    const event = useRequestEvent();
    const pageData = event?.context?.pageData;
    
    nuxtApp.payload.data.PACKAGES = pageData?.packages || [];

    if (pageData?.packages) delete pageData.packages;

    nuxtApp.payload.data.INITAPP = pageData || {};
  }

  if (import.meta.client) {
    const { siteData } = useSiteDataOnClient();

    if (siteData.value?.providerConfigs) {
      const { setProviderConfig } = usePaymentStore(usePinia());

      for (const [key, data] of Object.entries(siteData.value.providerConfigs)) {
        setProviderConfig(key as PaymentProvider, data as Record<string, any>, siteData.value?.countryCode || '');
      }
    }
  }
});
